import React, { useEffect, useState } from "react";
import Breadcrumb from "../components/Reusable/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserRewardList } from "../actions/reward";
import UserRewardListItem from "./UserRewardListItem";
import InfoBox from "../components/Reusable/InfoBox";
import { t } from "i18next"; // Import t function for translation

const UserReward = () => {
  const [activeTab, setActiveTab] = useState(0);
  const dispatch = useDispatch();

  const { rewardUserList } = useSelector((state) => state.rewardReducer);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  useEffect(() => {
    dispatch(fetchUserRewardList());
  }, [dispatch]);

  return (
    <div className="user-reward-main-container">
      <Breadcrumb title={t("userReward.breadcrumbTitle")} returnPage="/" />
      <div className="user-reward-list-container">
        {/* <div className="user-reward-category-items">
          <div
            className={`user-reward-category-item ${
              activeTab === 0 ? "active" : ""
            }`}
            onClick={() => handleTabClick(0)}
          >
            {t("userReward.tabSent")}
          </div>
          <div
            className={`user-reward-category-item ${
              activeTab === 2 ? "active" : ""
            }`}
            onClick={() => handleTabClick(2)}
          >
            {t("userReward.tabAccepted")}
          </div>
          <div
            className={`user-reward-category-item ${
              activeTab === 1 ? "active" : ""
            }`}
            onClick={() => handleTabClick(1)}
          >
            {t("userReward.tabRejected")}
          </div>
        </div> */}
        <div className="user-reward-list-items">
          {rewardUserList?.length > 0 ? (
            rewardUserList?.map((item, key) => (
              <UserRewardListItem data={item} key={key} />
            ))
          ) : (
            <InfoBox text={t("userReward.noRewardsMessage")} />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserReward;
